import React, { Component } from 'react';
import { Flex } from 'react-flex';
import 'react-flex/index.css';

import './DataPicker.css';

class DataPicker extends Component {
  constructor(props) {
    super(props);
    var selectValue = this.props.selectValue;
    this.state = this._generateState(selectValue, this.props.data);

    this._typeSelected = this._typeSelected.bind(this);
    this._sliderValueOnChange = this._sliderValueOnChange.bind(this);
    this._formSmallValueOnChange = this._formSmallValueOnChange.bind(this);
    this._formLargeValueOnChange = this._formLargeValueOnChange.bind(this);
    this._radioOnChange = this._radioOnChange.bind(this);
    this._generateState = this._generateState.bind(this);
    this._getPrefix = this._getPrefix.bind(this);
    this._getPostfix = this._getPostfix.bind(this);
  }

  _generateState(selectValue, data) {
    if (!selectValue) {
      return {
        sliderValues: [0, 0],
        smallValue: 0,
        largeValue: 0,
        min:0,
        max:0,
        sortType: null
      };
    } else {
      if (!data) {
        return {
          sliderValues: [selectValue.defaultMin,selectValue.defaultMax],
          smallValue: selectValue.defaultMin,
          largeValue: selectValue.defaultMax,
          min:selectValue.min,
          max:selectValue.max,
        };
      } else {
        return {
          sliderValues: data,
          smallValue: data.smallValue,
          largeValue: data.largeValue,
          min:selectValue.min,
          max:selectValue.max,
        };
      }
    }
  }

  _getPrefix() {
    return this.props.selectValue ? this.props.selectValue.preFix: "";
  }

  _getPostfix() {
    return this.props.selectValue ? " " + this.props.selectValue.postFix : "";
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this._generateState(nextProps.selectValue, nextProps.data));
  }

  _typeSelected() { return this.props.selectValue != null && this.props.selectValue.value != null; }

  _sliderValueOnChange(newValue)  {
    this.setState({ sliderValues: newValue });
    this.props.dataUpdate({
      smallValue: newValue[0],
      largeValue: newValue[1]
    });
  }
  _formSmallValueOnChange(event) {
    this.setState({ smallValue: event.target.value });
    this.props.dataUpdate({
      smallValue: event.target.value,
      largeValue: this.state.largeValue
    });
  }
  _formLargeValueOnChange(event) {
    this.setState({ largeValue: event.target.value });
    this.props.dataUpdate({
      smallValue: this.state.smallValue,
      largeValue: event.target.value
    });
  }
  _radioOnChange(event) {
    var value = event.target.value;
    this.setState({sortType: value});
    this.props.dataUpdate(value);
  }

	render() {
    // slider helper
    let _mapSliderValues = (v, f, context) => {
      return (v && v.map) ? v.map(f, context) : f.call(context, v, 0);
    }

    // component types
    let text = ( <text>{this.props.selectValue || "error"}</text> )
    let rangePicker = () => {
      return (
        <Flex row className="range" alignItems="center">
          <Flex row flex={1}>
            <label className="pickerText">Minimum</label>
            <i>{this._getPrefix()}</i>
            <input
                type="number"
                value={this.state.smallValue}
                onChange={this._formSmallValueOnChange}
                className="number-input"
            />
            <span className="pickerText">{this._getPostfix()}</span>
          </Flex>
          <Flex row flex={1}>
            <label className="pickerText">Maximum</label>
            <i>{this._getPrefix()}</i>
            <input
                type="number"
                value={this.state.largeValue}
                onChange={this._formLargeValueOnChange}
                className="number-input"
            />
            <span className="pickerText">{this._getPostfix()}</span>
          </Flex>
        </Flex>
      );
    }
    let sortRadioButton = (
      <Flex row style={{}}>
				<Flex row flex={1}>
        	<input
							type="radio"
							value="Smallest"
              id="smallest"
							checked={this.state.sortType === "Smallest"}
							onChange={this._radioOnChange} />
					<label htmlFor="smallest">Smallest first</label>
				</Flex>
				<Flex row flex={1}>
					<input
							type="radio"
							value="Largest"
              id="largest"
							checked={this.state.sortType === "Largest"}
							onChange={this._radioOnChange} />
					<label htmlFor="largest">Largest first</label>
				</Flex>
			</Flex>
    )

    // component selector
    let dataPicker = () => {
      switch (this.props.selectValue ? this.props.selectValue.value : null) {
        case "ev":
        case "cap":
        case "pbr":
        case "per":
          return rangePicker(false);
        case "sort":
          return sortRadioButton;
        default:
          return rangePicker(true);
      }
    }

    // render
		return (
      <div className="body">
        <div className={this._typeSelected() ? "bubbleOn" : "bubbleOff"}>
          {dataPicker()}
        </div>
      </div>
		);
	}
}

export default DataPicker;



// WEBPACK FOOTER //
// ./src/components/criterion/DataPicker.js